import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INextArticle } from 'next-common';

interface ArticlesState {
  articles: INextArticle[];
}

const initialState: ArticlesState = {
  articles: [],
};

const articlesSlice = createSlice({
  name: 'articles',
  initialState,
  reducers: {
    setArticles: (state, action: PayloadAction<INextArticle[]>) => {
      state.articles = action.payload;
    },
  },
});

export const { setArticles } = articlesSlice.actions;
export default articlesSlice.reducer;
